import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';

import ContractorAuthenticationModal from '../../../../components/family-plaza/ContractorAuthenticationModal';
import PortraitPhotoRegistrationModal from '../../../../components/family-plaza/PortraitPhotoRegistrationModal';
import { checkModalAuthenticationStatus, requireAuthentication } from '../../../../utils/authUtils';
import { getUserInfo } from '../../../../utils/auth';
import { createMemorialPost, updateMemorialPost, createCherishLetter } from '../../../../api';
import DeceasedPersonProfile from '../../../../components/family-plaza/DeceasedPersonProfile';
import FamilyPlazaTopSection from '../../../../components/family-plaza/FamilyPlazaTopSection';
import FamilyPlazaSubHeading from '../../../../components/family-plaza/FamilyPlazaSubHeading';

const MemorialPostWritingPC = () => {
  const navigate = useNavigate();
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [password, setPassword] = useState('');
  const [isPrivate, setIsPrivate] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingPostId, setEditingPostId] = useState(null);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [showPhotoModal, setShowPhotoModal] = useState(false);
  const [profilePhotoUrl, setProfilePhotoUrl] = useState('/donate/layer-1910.png');
  const handleNavigation = (route) => { navigate(route); };

  
  // Load existing post data for edit mode
  useEffect(() => {
    const selectedPostData = localStorage.getItem('selectedMemorialPost');
    if (selectedPostData) {
      try {
        const postData = JSON.parse(selectedPostData);
        setTitle(postData.title || '');
        setContent(postData.content || '');
        setPassword(postData.password || '');
        setIsPrivate(postData.isPrivate || false);
        setIsEditMode(true);
        setEditingPostId(postData.id);
      } catch (error) {
        console.error('Error parsing selected post data:', error);
      }
    }
  }, []);

  const handleCancel = () => {
    // Clear the selected post data if in edit mode
    if (isEditMode) {
      localStorage.removeItem('selectedMemorialPost');
    }
    navigate('/memorial-post-board-list');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Check if user has already completed the authentication modal
    if (!checkModalAuthenticationStatus()) {
      // If not authenticated, show authentication modal
      setShowAuthModal(true);
      return;
    }
    
    // If authenticated, proceed with form submission
    // Get customer name from localStorage
    const selectedPersonData = localStorage.getItem('selectedPersonData');
    let customerName = 'default';
    
    if (selectedPersonData) {
      try {
        const personData = JSON.parse(selectedPersonData);
        customerName = personData.customerName || 'default';
      } catch (error) {
        customerName = 'default';
      }
    }
    
    try {
      const selectedPersonData = localStorage.getItem('selectedPersonData');
      let goinId = null;
      
      if (selectedPersonData) {
        try {
          const personData = JSON.parse(selectedPersonData);
          goinId = personData.goinId || null;
        } catch (error) {
          goinId = null;
        }
      }
      
      // Get registId from userInfo
      const userInfo = getUserInfo();
      const registId = userInfo?.userId || userInfo?.id || 0;
      
      // Use the new cherish write API
      const cherishData = {
        cherishId: 0,
        goinId: goinId || 0,
        registId: registId,
        letterTitle: title.trim(),
        letterContents: content.trim(),
        password: password
      };
      
      const response = await createCherishLetter(cherishData);
      
      if (response && response.status === 200) {
        console.log('Memorial post created successfully via cherish API');
      } else {
        console.log('Cherish API failed, falling back to old API');
        
        // Fallback to old API
        const postData = {
          boardId: 1,
          title: title.trim(),
          content: content.trim(),
          password: password,
          isPrivate: isPrivate,
          author: 'Anonymous'
        };
        
        if (isEditMode) {
          await updateMemorialPost({
            ...postData,
            id: editingPostId
          });
        } else {
          await createMemorialPost(postData);
        }
      }
      
      // Also save to localStorage as backup
      const postsKey = `memorialPosts_${customerName}`;
      const existingPosts = localStorage.getItem(postsKey);
      let posts = [];
      
      if (existingPosts) {
        try {
          posts = JSON.parse(existingPosts);
        } catch (error) {
          posts = [];
        }
      }
      
      // Create new post object for localStorage
      const newPost = {
        id: isEditMode ? editingPostId : Date.now().toString(),
        title: title.trim(),
        content: content.trim(),
        password: password,
        isPrivate: isPrivate,
        customerName: customerName,
        date: new Date().toISOString(),
        author: 'Anonymous'
      };
      
      if (isEditMode) {
        // Update existing post in localStorage
        const postIndex = posts.findIndex(post => post.id === editingPostId);
        if (postIndex !== -1) {
          posts[postIndex] = { ...posts[postIndex], ...newPost };
        }
      } else {
        // Add new post to localStorage
        posts.unshift(newPost);
      }
      
      // Sort by date - most recent first
      const sortedPosts = posts.sort((a, b) => {
        const dateA = new Date(a.date);
        const dateB = new Date(b.date);
        return dateB - dateA; // Descending order (newest first)
      });
      
      // Save back to localStorage
      localStorage.setItem(postsKey, JSON.stringify(sortedPosts));
      
      // Clear the selected post data if in edit mode
      if (isEditMode) {
        localStorage.removeItem('selectedMemorialPost');
      }
      
      // Dispatch event to notify other components
      window.dispatchEvent(new CustomEvent('memorialPostUpdated', {
        detail: {
          customerName: customerName,
          postData: isEditMode ? { id: editingPostId, title, content, password, isPrivate } : null
        }
      }));
      
      // Navigate to the memorial post board list
      navigate('/memorial-post-board-list');
      
    } catch (error) {
      console.error('API failed, falling back to localStorage only:', error);
      
      // Fallback to localStorage only if API fails
    const postsKey = `memorialPosts_${customerName}`;
    const existingPosts = localStorage.getItem(postsKey);
    let posts = [];
    
    if (existingPosts) {
      try {
        posts = JSON.parse(existingPosts);
      } catch (error) {
        posts = [];
      }
    }
    
      // Create new post object
    const newPost = {
      id: isEditMode ? editingPostId : Date.now().toString(),
      title: title.trim(),
      content: content.trim(),
      password: password,
      isPrivate: isPrivate,
      customerName: customerName,
      date: new Date().toISOString(),
      author: 'Anonymous'
    };
    
    if (isEditMode) {
      // Update existing post
      const postIndex = posts.findIndex(post => post.id === editingPostId);
      if (postIndex !== -1) {
        posts[postIndex] = { ...posts[postIndex], ...newPost };
      }
    } else {
      // Add new post
      posts.unshift(newPost);
    }
      
      // Sort by date - most recent first
      const sortedPosts = posts.sort((a, b) => {
        const dateA = new Date(a.date);
        const dateB = new Date(b.date);
        return dateB - dateA; // Descending order (newest first)
      });
    
    // Save back to localStorage
      localStorage.setItem(postsKey, JSON.stringify(sortedPosts));
    
    // Clear the selected post data if in edit mode
    if (isEditMode) {
      localStorage.removeItem('selectedMemorialPost');
    }
    
    // Dispatch event to notify other components
    window.dispatchEvent(new CustomEvent('memorialPostUpdated', {
      detail: {
        customerName: customerName,
        postData: isEditMode ? { id: editingPostId, title, content, password, isPrivate } : null
      }
    }));
    
    // Navigate to the memorial post board list
    navigate('/memorial-post-board-list');
    }
  };

  // Photo icon click handler
  const handlePhotoIconClick = () => {
    const isAuthenticated = checkModalAuthenticationStatus();
    
    if (isAuthenticated) {
      // If already authenticated, open photo modal directly
      setShowPhotoModal(true);
    } else {
      // If not authenticated, open auth modal first
      setShowAuthModal(true);
    }
  };

  // Authentication modal handlers
  const handleAuthConfirm = () => {
    setShowAuthModal(false);
    // After successful authentication, proceed with form submission
    handleSubmitAfterAuth();
  };

  const handleAuthClose = () => {
    setShowAuthModal(false);
  };

  // Handle form submission after authentication
  const handleSubmitAfterAuth = () => {
    // Get customer name from localStorage
    const selectedPersonData = localStorage.getItem('selectedPersonData');
    let customerName = 'default';
    
    if (selectedPersonData) {
      try {
        const personData = JSON.parse(selectedPersonData);
        customerName = personData.customerName || 'default';
      } catch (error) {
        customerName = 'default';
      }
    }
    
    // Get existing posts from localStorage
    const postsKey = `memorialPosts_${customerName}`;
    const existingPosts = localStorage.getItem(postsKey);
    let posts = [];
    
    if (existingPosts) {
      try {
        posts = JSON.parse(existingPosts);
      } catch (error) {
        posts = [];
      }
    }
    
    // Create new post or update existing one
    const newPost = {
      id: isEditMode ? editingPostId : Date.now().toString(),
      title: title.trim(),
      content: content.trim(),
      password: password,
      isPrivate: isPrivate,
      customerName: customerName,
      date: new Date().toISOString(),
      author: 'Anonymous'
    };
    
    if (isEditMode) {
      // Update existing post
      const postIndex = posts.findIndex(post => post.id === editingPostId);
      if (postIndex !== -1) {
        posts[postIndex] = { ...posts[postIndex], ...newPost };
      }
    } else {
      // Add new post
      posts.unshift(newPost);
    }
    
    // Sort by date - most recent first
    const sortedPosts = posts.sort((a, b) => {
      const dateA = new Date(a.date);
      const dateB = new Date(b.date);
      return dateB - dateA; // Descending order (newest first)
    });
    
    // Save back to localStorage
    localStorage.setItem(postsKey, JSON.stringify(sortedPosts));
    
    // Clear the selected post data if in edit mode
    if (isEditMode) {
      localStorage.removeItem('selectedMemorialPost');
    }
    
    // Dispatch event to notify other components
    window.dispatchEvent(new CustomEvent('memorialPostUpdated', {
      detail: {
        customerName: customerName,
        postData: isEditMode ? { id: editingPostId, title, content, password, isPrivate } : null
      }
    }));
    
    // Navigate to the memorial post board list
    navigate('/memorial-post-board-list');
  };

  // Photo registration modal handlers
  const handlePhotoConfirm = () => {
    setShowPhotoModal(false);
  };

  const handlePhotoUpload = (photoUrl) => {
    console.log('Photo uploaded, updating profile photo:', photoUrl.substring(0, 50) + '...');
    // Update profile photo immediately when photo is uploaded
    setProfilePhotoUrl(photoUrl);
  };

  const handlePhotoClose = () => {
    setShowPhotoModal(false);
  };

  return (
    <div className="memorial-post-writing-pc page-memorial-post-writing-pc announcement-list-page cyber-info-page-pc">
      
      <FamilyPlazaTopSection />
  
     <main className="main-content">
  
      <FamilyPlazaSubHeading heading="사이버추모관" />
      
    

      {/* Main Content */}
      <div className="memorial-post-writing-main-content">
        <div className="memorial-post-writing-page-content">
          <div className="memorial-post-writing-container">
            
            {/* Profile Section - HORIZONTAL LAYOUT */}
            <DeceasedPersonProfile 
              handlePhotoIconClick={handlePhotoIconClick}
            />
           
            {/* Action Tabs Navigation */}
            <div className="memorial-post-writing-action-tabs">
              <div className="memorial-post-writing-action-tabs-container">
                <ul>
                  <li><Link to="/donate">헌화하기</Link></li>
                  <li><Link to="/memorial-post-board-list" className="active">추모글</Link></li>
                  <li><Link to="/memorial-album-board-list">추모앨범</Link></li>
                </ul>
              </div>
            </div>

            {/* Content Area - Writing Form */}
            <div className="memorial-post-writing-content-area">
              
              {/* Writing Form */}
              <div className="memorial-post-writing-form">
                <div className="memorial-post-writing-form-group">
                  <div className="memorial-post-writing-form-row">
                    <label className="memorial-post-writing-form-label">제목 *</label>
                    <div className="memorial-post-writing-form-input-container">
                      <div className="memorial-post-writing-form-input-row">
                        <input 
                          type="text" 
                          className="memorial-post-writing-form-input" 
                          value={title}
                          onChange={(e) => setTitle(e.target.value)}
                        />
                        <div className="memorial-post-writing-private-checkbox">
                          <input 
                            type="checkbox" 
                            id="private-post" 
                            checked={isPrivate}
                            onChange={(e) => setIsPrivate(e.target.checked)}
                            className="memorial-post-writing-checkbox"
                          />
                          <label htmlFor="private-post" className="memorial-post-writing-checkbox-label">비밀글 등록</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div className="memorial-post-writing-form-group">
                  <div className="memorial-post-writing-form-row">
                    <label className="memorial-post-writing-form-label">비밀번호 *</label>
                    <div className="memorial-post-writing-form-input-container">
                      <div className="memorial-post-writing-form-input-row">
                        <input 
                          type="password" 
                          className="memorial-post-writing-form-input" 
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                        />
                        <span className="memorial-post-writing-hint">영문+숫자 10자리 미만</span>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div className="memorial-post-writing-form-group">
                  <div className="memorial-post-writing-form-row">
                    <label className="memorial-post-writing-form-label">내용 *</label>
                    <div className="memorial-post-writing-form-input-container">
                      <textarea 
                        className="memorial-post-writing-form-textarea" 
                        placeholder="내용을 입력해주세요."
                        rows="10"
                        value={content}
                        onChange={(e) => setContent(e.target.value)}
                      ></textarea>
                    </div>
                  </div>
                </div>
                
                <div className="memorial-post-writing-form-actions">
                  <button className="memorial-post-writing-cancel-btn" onClick={handleCancel}>취소</button>
                  <button 
                    className="memorial-post-writing-submit-btn"
                    onClick={handleSubmit}
                  >{isEditMode ? '수정' : '등록'}</button>
                </div>
              </div>
              
            </div>

          </div>
        </div>
      </div>

      

      {/* Authentication Modal */}
      <ContractorAuthenticationModal
        isOpen={showAuthModal}
        onConfirm={handleAuthConfirm}
        onClose={handleAuthClose}
      />

      {/* Photo Registration Modal */}
      <PortraitPhotoRegistrationModal
        isOpen={showPhotoModal}
        onConfirm={handlePhotoConfirm}
        onClose={handlePhotoClose}
        onPhotoUpload={handlePhotoUpload}
      />
      </main>
    </div>
  );
};

export default MemorialPostWritingPC; 
